/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Waypoint from "../../models/Waypoint";

export default {
	// Calendar Labels
	eventSatusLabels: [],
	// Simple Calendar State
	events: [],
	events_per_day_reorder: [],
	unsavedEvents: [],
	selectedEvents: [],
	//current resource
	currentResourceId: 0,
	currentResource: {},
	calendarDate: null,
	reassignDate: null,
	reloadCounter: 0,
	showMap: true,
	waypoint: new Waypoint({}),
	waypoints: [],
	followers: [],
	scheduleFollowers: [],
	// create set to save all of request to avoid duplicate request to server on maps static image request
	scheduleMapStaticImageRequests: new Map(), // the key is visit point point id and value is the request promise
	templates: [],
	cachedEvents: [],
};
